import colors from '../theme/colors';
import palette from '../theme/palette';

const variants = [
  {
    props: { color: 'internal' },
    style: {
      color: `${palette.internal.main} !important`,
      '&:hover': {
        color: `${colors.internal['700']} !important`,
      },
    },
  },
  {
    props: { textColor: 'primary' },
    style: {
      color: palette.text.primary,
    },
  },
];

export default variants;
